<div class="catalog-footer-background hide-xs">
  @if (patronSelectors.hasPatron | select) {
    <div class="catalog-footer-body">
      <div class="catalog-footer-section flex-row">
        <div class="flex-col flex-gap-16 flex-1">
          <div class="flex-row flex-center-start">
            <img style="height: 25px; width: 25px" alt="Library Logo" src="/assets/mx-logo.png"/>
            <h3 style="margin: 0 8px">{{ organizationSelectors.name | select }}</h3>
          </div>
          <div class="flex-row flex-center-start">
            <img alt="notifications" src="/assets/slicons/arrow_backward.svg"/>
            <a routerLink="/dashboard">Library Home</a>
          </div>
          @if (branch$ | async; as branch) {
            <div>
              <span class="footer-heading">Branch Location</span><br/>
              @if (branch.address && branch.phone) {
                <span>{{ branchSelectors.address }}</span><br/>
                @if (branchSelectors.address2 | select) {
                  <span>{{ branchSelectors.address2 | select }}<br/></span>
                }
                <span>{{ branchSelectors.city | select }}, {{ branchSelectors.state | select }} {{ branchSelectors.zipCode | select }}</span><br/>
                <span>{{ branchSelectors.phone | select }}</span>
              } @else {
                <span>1234 Street Name</span><br/>
                <span>City, ST, 12345</span><br/>
                <span>123-456-7790</span>
              }
            </div>
          }
        </div>
        <div class="flex-col flex-gap-16 flex-1">
          <a routerLink="/catalog">Catalog</a>
          <a routerLink="/checkouts">Items Out</a>
          <a routerLink="/holds">On Hold</a>
          <a>Requests</a>
          <a routerLink="/favorites">Favorites</a>
          <a routerLink="/my-card">Library Card</a>
        </div>
        <div class="flex-col flex-gap-16 flex-1">
          <a (click)="routingService.goToProfile()">Account</a>
          <a (click)="routingService.goToPatronBilling()">Fees and Fines</a>
          <a (click)="routingService.goToNotificationPreferences()">Notification Preferences</a>
        </div>
      </div>
      <hr/>
      <div class="flex-row flex-center-space-between" style="padding: 20px 0">
        <div>
          <span>Powered by Simplicity™ All rights reserved &copy;{{ currentYear }}</span>
        </div>
        <div>
          <a href="https://www.simplicity-ils.com/terms-of-service" target="_blank" rel="noopener noreferrer">Simplicity Terms and Conditions</a>
          <span> | </span>
          <a href="https://www.simplicity-ils.com/privacy-policy" target="_blank" rel="noopener noreferrer">Simplicity Privacy Policy</a>
          <span> | </span>
          <a href="https://www.simplicity-ils.com/sms-notification-terms" target="_blank" rel="noopener noreferrer">SMS Notification Terms</a>
        </div>
        <div>
          <a routerLink="/logout">Sign Out</a>
        </div>
      </div>
    </div>
  } @else {
    <div class="catalog-footer-body">
      <div class="flex-row flex-center-space-between" style="padding: 20px 0">
        <div>
          <span>Powered by Simplicity™ All rights reserved &copy;{{ currentYear }}</span>
        </div>
        <div>
          <a href="https://www.simplicity-ils.com/terms-of-service" target="_blank" rel="noopener noreferrer">Simplicity Terms and Conditions</a>
          <span> | </span>
          <a href="https://www.simplicity-ils.com/privacy-policy" target="_blank" rel="noopener noreferrer">Simplicity Privacy Policy</a>
          <span> | </span>
          <a href="https://www.simplicity-ils.com/sms-notification-terms" target="_blank" rel="noopener noreferrer">SMS Notification Terms</a>
        </div>
        <div></div>
      </div>
    </div>
  }
</div>
